import { useLang } from "../i18n/LangContext";

export default function Footer() {
    const { t, lang } = useLang();
    const year = new Date().getFullYear();
    const go = (id) =>
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

    // Top 5 services flattened from groups (excluding purchasing which is featured)
    const topServices = (t.services?.groups || [])
        .flatMap((g) => g.items)
        .slice(0, 5);

    return (
        <footer
            data-testid="site-footer"
            className="bg-ink text-white pt-16 md:pt-20 pb-8"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-white/15">
                    <div className="md:col-span-5">
                        <div className="flex items-center">
                            <img
                                src="/sitmec-logo.jpg"
                                alt="SITMEC"
                                className="h-14 w-auto object-contain"
                            />
                        </div>
                        <p className="mt-5 font-display text-mint text-sm uppercase tracking-[0.3em]">
                            {t.footer.tagline}
                        </p>
                        <p className="mt-4 text-white/60 text-sm max-w-md leading-relaxed">
                            {lang === "fr"
                                ? "Centrale d'achats internationale et services techniques industriels — maintenance, GTB, électricité, climatisation."
                                : "International purchasing hub and industrial technical services — maintenance, BMS, electrical, HVAC."}
                        </p>
                        <p className="mt-5 text-white/40 text-xs leading-relaxed">
                            {t.footer.legal}
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-display text-xs uppercase tracking-widest text-mint mb-5">
                            {t.footer.sections.services}
                        </div>
                        <ul className="space-y-3 text-sm text-white/80">
                            <li>
                                <button
                                    onClick={() => go("purchasing")}
                                    className="hover:text-mint transition-colors text-left font-semibold"
                                >
                                    {t.nav.purchasing} ★
                                </button>
                            </li>
                            {topServices.map((s) => (
                                <li key={s.id}>
                                    <button
                                        onClick={() => go("services")}
                                        className="hover:text-mint transition-colors text-left"
                                    >
                                        {s.title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="font-display text-xs uppercase tracking-widest text-mint mb-5">
                            {t.footer.sections.company}
                        </div>
                        <ul className="space-y-3 text-sm text-white/80">
                            <li>
                                <button
                                    onClick={() => go("about")}
                                    className="hover:text-mint transition-colors"
                                >
                                    {t.nav.about}
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => go("method")}
                                    className="hover:text-mint transition-colors"
                                >
                                    {t.nav.method}
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => go("cases")}
                                    className="hover:text-mint transition-colors"
                                >
                                    {t.nav.cases}
                                </button>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="font-display text-xs uppercase tracking-widest text-mint mb-5">
                            {t.footer.sections.contact}
                        </div>
                        <ul className="space-y-3 text-sm text-white/80">
                            {t.contact.info.emails.map((em) => (
                                <li key={em}>
                                    <a
                                        href={`mailto:${em}`}
                                        className="hover:text-mint transition-colors"
                                        data-testid={`footer-email-${em.split("@")[0]}`}
                                    >
                                        {em}
                                    </a>
                                </li>
                            ))}
                            {t.contact.info.whatsappLink && (
                                <li>
                                    <a
                                        href={t.contact.info.whatsappLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="footer-whatsapp"
                                        className="hover:text-mint transition-colors"
                                    >
                                        WhatsApp
                                    </a>
                                </li>
                            )}
                            <li className="text-white/60 leading-relaxed">
                                {t.contact.info.address}
                            </li>
                            <li className="pt-2">
                                <button
                                    onClick={() => go("contact")}
                                    className="hover:text-mint transition-colors"
                                    data-testid="footer-cta"
                                >
                                    {t.nav.cta} →
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/50">
                    <div>
                        © {year} SITMEC. {t.footer.rights}
                    </div>
                    <div className="font-display uppercase tracking-widest">
                        {t.meta.tagline}
                    </div>
                </div>
            </div>
        </footer>
    );
}
